/**
 * Banner validation for UI_UPDATE payloads.
 * Only canonical types are allowed; unknown types are logged and rejected.
 */

import { isCanonicalBannerType, BANNER_LOG_KEYS } from '../components/BannerNotification';

export type AddBannerFn = (banner: {
  type: string;
  title?: string;
  message?: string;
  dismissTime?: number;
}) => void;

/**
 * Validates payload and either adds banner or logs error.
 * Unknown types: log structured error, throw in dev, never render.
 */
export function processUiUpdateBanner(
  payload: { type?: string; title?: string; message?: string; durationMs?: number; dismissTime?: number },
  meetingId: string,
  addBanner: AddBannerFn
): void {
  const bannerType = payload.type;
  if (!bannerType || !isCanonicalBannerType(bannerType)) {
    const typeForLog = bannerType === '' || bannerType == null ? '(empty)' : bannerType;
    console.error(`[${BANNER_LOG_KEYS.UI_BANNER_UNKNOWN_TYPE}]`, {
      type: typeForLog,
      meetingId,
    });
    if (typeof process !== 'undefined' && process.env?.NODE_ENV !== 'production') {
      throw new Error(`Unknown banner type: ${typeForLog}. Only canonical types are allowed.`);
    }
    return;
  }
  const fromMessage = typeof payload.message === 'string' ? payload.message.trim() : '';
  const fromTitle = typeof payload.title === 'string' ? payload.title.trim() : '';
  const insightFallback = bannerType === 'insight_candidate_detected' ? 'Meeting Output Detected' : '';
  const line = fromMessage || fromTitle || insightFallback;
  const dismissTime = payload.durationMs ?? payload.dismissTime;
  addBanner({
    type: bannerType,
    message: line,
    ...(dismissTime != null && dismissTime > 0 && { dismissTime }),
  });
}
